<div [class]="data.theme || 'default-theme'">
  <mat-toolbar color="primary">
    <h1 class="ellipsis-text">{{data.title | async}}</h1>
    <span fxFlex></span>
    <button *ngIf="data.onClose" mat-icon-button (click)="handleAction(data.onClose)">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <div class="progress-bar-wrapper">
    <mat-progress-bar mode="indeterminate" *ngIf="subscription != null">
    </mat-progress-bar>
  </div>
  <mat-dialog-content>
    {{data.message | async}}
  </mat-dialog-content>
  <mat-dialog-actions>
    <span fxFlex></span>
    <ng-container *ngIf="data.buttons">
      <ng-container *ngFor="let action of data.buttons; let last = last">
        <button mat-button
                [disabled]="subscription != null"
                (click)="handleAction(action.onClick)"
                [attr.cdkFocusInitial]="last ? '' : null">
          {{action.label | async}}
        </button>
      </ng-container>
    </ng-container>
  </mat-dialog-actions>
</div>
